export enum Theme {
  BASE = 'theme-base',
  ACCESSIBLE_WHITE = 'theme-accessible-white',
  ACCESSIBLE_BlACK = 'theme-accessible-black'
}
